import { IExtendedContext } from '../../../types/extendedContext';
import { loadPublishTerms } from '../../../../shared/ServicePickerWidget/thunks/publishTerms/loadPublishTerms';

export const reloadPublishTermsHandler = (context: IExtendedContext) => () => {
  return context.store.dispatch(loadPublishTerms());
};
